<div class="sc-date-picker" [class.readonly]="readOnly" [class.disabled]="disabled">
    <sc-input
        bsDatepicker
        [bsValue]="auxFormControl.value"
        [bsConfig]="datePickerConfig"
        (bsValueChange)="handleValueChange($event)"
        [maxDate]="maxDate"
        [minDate]="minDate"
        [hideError]="hideError"
        [pipes]="[{pipe: datePipe, pipeParams: dateFormat}, {pipe: titleCasePipe }]"
        [label]="label"
        [readonly]="true"
        [isDisabled]="disabled"
        [formControl]="auxFormControl"
        [debounceTime]="debounceTime"
        [placement]="placement"
        [placeholder]="placeholder"
        [container]="container"
        type="text"
        icon="calendar"
    ></sc-input>
</div>